/* tslint:disable */
/* eslint-disable */
/**
 * NN.CustomerPortal.ApiApp.General
 * GeneralAPIs
 *
 * The version of the OpenAPI document: 1.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { AddressType } from './AddressType';
import {
    AddressTypeFromJSON,
    AddressTypeFromJSONTyped,
    AddressTypeToJSON,
    AddressTypeToJSONTyped,
} from './AddressType';

/**
 * 
 * @export
 * @interface AddressRequest
 */
export interface AddressRequest {
    /**
     * 
     * @type {AddressType}
     * @memberof AddressRequest
     */
    type: AddressType;
    /**
     * 
     * @type {string}
     * @memberof AddressRequest
     */
    street: string;
    /**
     * 
     * @type {string}
     * @memberof AddressRequest
     */
    houseNumber?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AddressRequest
     */
    town: string;
    /**
     * 
     * @type {string}
     * @memberof AddressRequest
     */
    zip: string;
    /**
     * 
     * @type {string}
     * @memberof AddressRequest
     */
    country: string;
    /**
     * 
     * @type {string}
     * @memberof AddressRequest
     */
    note?: string | null;
}



/**
 * Check if a given object implements the AddressRequest interface.
 */
export function instanceOfAddressRequest(value: object): value is AddressRequest {
    if (!('type' in value) || value['type'] === undefined) return false;
    if (!('street' in value) || value['street'] === undefined) return false;
    if (!('town' in value) || value['town'] === undefined) return false;
    if (!('zip' in value) || value['zip'] === undefined) return false;
    if (!('country' in value) || value['country'] === undefined) return false;
    return true;
}

export function AddressRequestFromJSON(json: any): AddressRequest {
    return AddressRequestFromJSONTyped(json, false);
}

export function AddressRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): AddressRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'type': AddressTypeFromJSON(json['type']),
        'street': json['street'],
        'houseNumber': json['houseNumber'] == null ? undefined : json['houseNumber'],
        'town': json['town'],
        'zip': json['zip'],
        'country': json['country'],
        'note': json['note'] == null ? undefined : json['note'],
    };
}

export function AddressRequestToJSON(json: any): AddressRequest {
    return AddressRequestToJSONTyped(json, false);
}

export function AddressRequestToJSONTyped(value?: AddressRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'type': AddressTypeToJSON(value['type']),
        'street': value['street'],
        'houseNumber': value['houseNumber'],
        'town': value['town'],
        'zip': value['zip'],
        'country': value['country'],
        'note': value['note'],
    };
}

